import React, { useState } from 'react'
import { FormLayout } from 'styles/FormLayout'
import { ReturnActionType, DisabledActionType, ShapeAction, Config, isCommon, UNSET } from 'domain/Assortment'
import { SelectAction } from '../CommonComponents'

export type ShapeActionSnapshotMultiselect = {
  returnAction?: ShapeAction
  disabledAction?: ShapeAction
}

export type DisabledShapeActionsMultiselect = {
  returnAction: boolean
  disabledAction: boolean
}

type Props = {
  config: Config
  id: string
  snapshot: ShapeActionSnapshotMultiselect
  disabled: DisabledShapeActionsMultiselect
  onApply: (id: string, snapshot: ShapeActionSnapshotMultiselect) => void
}

export const ShapeActionDialogMultiselect = ({ config, id, snapshot, disabled, onApply }: Props) => {
  const [returnAction, setReturnAction] = useState<ShapeAction | undefined>(snapshot.returnAction)
  const [disabledAction, setDisabledAction] = useState<ShapeAction | undefined>(snapshot.disabledAction)
  return (
    <div className="card">
      <FormLayout.Content>
        <h3 className="text-lg mb-md">Active actions</h3>
        <SelectAction
          label={'RETURN action:'}
          type={returnAction?.type}
          disabled={disabled.returnAction}
          showDisabled={isCommon(config)}
          allowOverride={returnAction?.allowOverride}
          options={[ReturnActionType.SET, ReturnActionType.CLEAR, ReturnActionType.REMOVE]}
          onTypeChanged={(value) => {
            if (value === UNSET) {
              setReturnAction(undefined)
            } else {
              setReturnAction({ ...returnAction, type: value as ReturnActionType })
            }
          }}
          onAllowOverrideChanged={(allow) => {
            if (returnAction) {
              setReturnAction({ ...returnAction, allowOverride: allow })
            }
          }}
        />
        <SelectAction
          label={'DISABLED action:'}
          type={disabledAction?.type}
          disabled={disabled.disabledAction}
          showDisabled={isCommon(config)}
          allowOverride={disabledAction?.allowOverride}
          options={[DisabledActionType.SET, DisabledActionType.CLEAR, DisabledActionType.REMOVE]}
          onTypeChanged={(value) => {
            if (value === UNSET) {
              setDisabledAction(undefined)
            } else {
              setDisabledAction({ ...disabledAction, type: value as DisabledActionType })
            }
          }}
          onAllowOverrideChanged={(allow) => {
            if (disabledAction) {
              setDisabledAction({ ...disabledAction, allowOverride: allow })
            }
          }}
        />
        <FormLayout.FooterContainer>
          <FormLayout.Footer>
            <button
              className="btn btn-primary-dark py-sm"
              onClick={() => {
                onApply(id, {
                  returnAction: returnAction,
                  disabledAction: disabledAction,
                })
              }}
            >
              <span>Ok</span>
            </button>
          </FormLayout.Footer>
        </FormLayout.FooterContainer>
      </FormLayout.Content>
    </div>
  )
}
